import { render, staticRenderFns } from "./ViewDocuments.vue?vue&type=template&id=3ee16f68&"
import script from "./ViewDocuments.vue?vue&type=script&lang=ts&"
export * from "./ViewDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDocuments.vue?vue&type=style&index=0&id=3ee16f68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports